import Skeleton from '@mui/material/Skeleton';
import Layout from '../../../common/Layout/Layout';
import styles from './SkeletonTrainingSummaryView.module.scss';
import { useId } from '../../../../lib/hooks/useId';
import { useInternalComponent } from '../../../../lib/context/InternalComponentContext';
import { classes } from '../../../../lib/utils/cssUtils';

type SkeletonTrainingProps = {
  containerClass: string;
};

type SkeletonTrainingSummaryViewProps = {
  disableHeader?: boolean;
};

const SkeletonTraining = ({ containerClass }: SkeletonTrainingProps) => {
  return (
    <div className={containerClass}>
      <Skeleton variant="rounded" className={styles.skeleton} />
    </div>
  );
};

const SkeletonTrainingSummaryView = ({ disableHeader = false }: SkeletonTrainingSummaryViewProps) => {
  const id = useId('skeleton-tile-');
  const { internal } = useInternalComponent();

  return (
    <Layout>
      <div className={classes(styles.grid, { [styles.fillContainer]: internal })}>
        {!disableHeader && (
          <div className={styles.titleRow}>
            <Skeleton variant="rectangular" className={styles.heading} />
          </div>
        )}
        <SkeletonTraining containerClass={styles.courseFirst} />
        {Array.from(new Array(4), (_, i) => i).map(value => (
          <SkeletonTraining key={`${id}${value}`} containerClass={styles.course} />
        ))}
      </div>
    </Layout>
  );
};

export default SkeletonTrainingSummaryView;
